import { useModals } from "@/features/modals/hooks";
import { type WidgetSettingsDefinition } from "@repo/api";
import { ListViewItem, warehouseIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateServices, useOrderedServices } from "@repo/ui";

export const ServicesSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { pushModal } = useModals();
  const services = useOrderedServices();

  const value = setting[settingDefinition.id];
  const selectedServices = (value ?? []).map((v: any) =>
    translateServices(services.find((s) => v == s[0])?.[1])
  );

  return (
    <ListViewItem
      control="navigational"
      title={t("label.services_interested")}
      description={
        selectedServices.length > 0 ? selectedServices.join(", ") : undefined
      }
      onClick={() => {
        pushModal({
          type: "SERVICES_INTERESTED",
          servicesInterested: value,
          onSave: (newSelectedServices) => {
            setSetting({
              ...setting,
              [settingDefinition.id]: newSelectedServices,
            });
            return Promise.resolve();
          },
        });
      }}
      leadingIcon={warehouseIcon}
    />
  );
};
